var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import HttpStatus from "http-status-codes";
import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import logger from "../../logger";
import * as loggerTypes from "../../logger/logger.types";
import * as socketActions from "../../redux/socket/socket.actions";
import { showAlert } from "../../utils/alert/alert.utils";
import { cancelPendingCalls } from "../../utils/api/api.utils";
import { getGeneralUpdateSuccessText, getLocalizedText, } from "../../utils/i18n/i18n.utils";
import * as contactActions from "../contact/contact.actions";
import { updateContact } from "../contact/contact.api";
import { EContactCustomId } from "../contact/contact.types";
import * as authActions from "./auth.actions";
import * as authApi from "./auth.api";
import { getUser, updateUser, updateUserById, removeProfile, } from "./auth.api";
import * as authSelectors from "./auth.selectors";
import * as authUtils from "./auth.utils";
function signOutFlow() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(authUtils.setAccessToken, undefined)];
            case 1:
                _a.sent();
                return [4 /*yield*/, call(authUtils.setRefreshToken, undefined)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function signInStartFlow(action) {
    var payload, phoneOrEmail, password, data, accessToken, refreshToken, userType, userTypePreference, unknownError_1, error, errorMessage, content, axiosError;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                payload = action.payload;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 5, , 7]);
                phoneOrEmail = payload.phoneOrEmail, password = payload.password;
                return [4 /*yield*/, call(authApi.signIn, {
                        emailOrPhone: phoneOrEmail,
                        password: password,
                    })];
            case 2:
                data = (_b.sent()).data;
                accessToken = data.accessToken, refreshToken = data.refreshToken, userType = data.userType;
                return [4 /*yield*/, call(authUtils.getUserType, data.userId)];
            case 3:
                userTypePreference = _b.sent();
                return [4 /*yield*/, put(authActions.signIn.actions.success({
                        accessToken: accessToken,
                        refreshToken: refreshToken,
                        // @ts-ignore
                        userType: userTypePreference || userType,
                        selectedDashboardType: authUtils.getDashboardPreference(userTypePreference, userType),
                    }))];
            case 4:
                _b.sent();
                return [3 /*break*/, 7];
            case 5:
                unknownError_1 = _b.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.signIn.actions.failure({ error: error }))];
            case 6:
                _b.sent();
                errorMessage = getLocalizedText("general.error");
                content = undefined;
                axiosError = error;
                if (axiosError.isAxiosError) {
                    switch ((_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.status) {
                        case HttpStatus.BAD_REQUEST:
                            errorMessage = getLocalizedText("system.wrong.password");
                            break;
                        case HttpStatus.PAYMENT_REQUIRED:
                            errorMessage = getLocalizedText("auth.sign_in.error.payment_required.title");
                            content = getLocalizedText("auth.sign_in.error.payment_required.content");
                            break;
                        default:
                            break;
                    }
                }
                showAlert({
                    type: "error",
                    message: errorMessage,
                    content: content,
                });
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function signInAutomaticallyStartFlow(action) {
    var payload, token, data, accessToken, refreshToken, userType, userTypePreference, unknownError_2, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 7]);
                token = payload.token;
                return [4 /*yield*/, call(authApi.signInAutomatically, token)];
            case 2:
                data = (_a.sent()).data;
                accessToken = data.accessToken, refreshToken = data.refreshToken, userType = data.userType;
                return [4 /*yield*/, call(authUtils.getUserType, data.userId)];
            case 3:
                userTypePreference = _a.sent();
                return [4 /*yield*/, put(authActions.signInAutomatically.actions.success({
                        accessToken: accessToken,
                        refreshToken: refreshToken,
                        // @ts-ignore
                        userType: userTypePreference || userType,
                        selectedDashboardType: authUtils.getDashboardPreference(userTypePreference, userType),
                    }))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5:
                unknownError_2 = _a.sent();
                error = unknownError_2;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.signInAutomatically.actions.failure({ error: error }))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function setAccessTokensWithoutSideEffectsFlow(action) {
    var payload, accessToken, refreshToken, unknownError_3, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                accessToken = payload.accessToken, refreshToken = payload.refreshToken;
                cancelPendingCalls();
                return [4 /*yield*/, call(authUtils.setAccessToken, accessToken)];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(authUtils.setRefreshToken, refreshToken)];
            case 3:
                _a.sent();
                return [3 /*break*/, 5];
            case 4:
                unknownError_3 = _a.sent();
                error = unknownError_3;
                logger.logError({ error: error });
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function signUpStartFlow(action) {
    var payload, locale, platform, firstname, lastname, email, phone, password, captcha, captchaVersion, role, tac, user, unknownError_4, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 8]);
                locale = payload.locale, platform = payload.platform, firstname = payload.firstname, lastname = payload.lastname, email = payload.email, phone = payload.phone, password = payload.password, captcha = payload.captcha, captchaVersion = payload.captchaVersion, role = payload.role;
                return [4 /*yield*/, call(authApi.getTac, locale, platform)];
            case 2:
                tac = (_a.sent()).data;
                return [4 /*yield*/, call(authApi.signUp, {
                        locale: locale,
                        tacId: tac.id,
                        firstname: firstname,
                        lastname: lastname,
                        unverifiedPhone: phone,
                        unverifiedEmail: email,
                        password: password,
                        captcha: captcha,
                        captchaVersion: captchaVersion,
                    })];
            case 3:
                user = (_a.sent()).data;
                return [4 /*yield*/, put(authActions.signUp.actions.success({ user: user }))];
            case 4:
                _a.sent();
                return [4 /*yield*/, call(authUtils.setUserType, user.id, role)];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                unknownError_4 = _a.sent();
                error = unknownError_4;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.signUp.actions.failure({ error: error }))];
            case 7:
                _a.sent();
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function signUpVerifyPhoneStartFlow(action) {
    var payload, code, user, _a, _b, _c, status_1, data, accessToken, refreshToken, unknownError_5, error;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                payload = action.payload;
                _d.label = 1;
            case 1:
                _d.trys.push([1, 7, , 9]);
                code = payload.code;
                _b = (_a = authSelectors).getUser;
                return [4 /*yield*/, select()];
            case 2:
                user = _b.apply(_a, [_d.sent()]);
                if (!user) {
                    throw new Error("No user");
                }
                return [4 /*yield*/, call(authApi.verifyPhone, user.id, code)];
            case 3:
                _c = _d.sent(), status_1 = _c.status, data = _c.data;
                if (!(status_1 === HttpStatus.NO_CONTENT)) return [3 /*break*/, 5];
                return [4 /*yield*/, put(authActions.signUpVerifyPhone.actions.failure({
                        error: new Error("Wrong code"),
                    }))];
            case 4:
                _d.sent();
                showAlert({
                    type: "error",
                    message: getLocalizedText("intake.verification.pincode.wrong"),
                });
                return [2 /*return*/];
            case 5:
                accessToken = data.accessToken, refreshToken = data.refreshToken;
                return [4 /*yield*/, put(authActions.signUpVerifyPhone.actions.success({
                        accessToken: accessToken,
                        refreshToken: refreshToken,
                    }))];
            case 6:
                _d.sent();
                return [3 /*break*/, 9];
            case 7:
                unknownError_5 = _d.sent();
                error = unknownError_5;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.signUpVerifyPhone.actions.failure({ error: error }))];
            case 8:
                _d.sent();
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function signUpRequestTokenFromEmailStartFlow() {
    var user, _a, _b, data, accessToken, refreshToken, unknownError_6, error;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 7, , 8]);
                _b = (_a = authSelectors).getUser;
                return [4 /*yield*/, select()];
            case 1:
                user = _b.apply(_a, [_c.sent()]);
                if (!user) {
                    throw new Error("No user");
                }
                return [4 /*yield*/, call(authApi.getAccessTokenFromEmail, user.id, user.unverifiedEmailRequestToken)];
            case 2:
                data = (_c.sent()).data;
                if (data.statusCode === HttpStatus.FORBIDDEN) {
                    showAlert({
                        type: "error",
                        message: getLocalizedText("profile.email.unverified"),
                    });
                    return [2 /*return*/];
                }
                accessToken = data.accessToken, refreshToken = data.refreshToken;
                if (!(accessToken && refreshToken)) return [3 /*break*/, 6];
                return [4 /*yield*/, call(authUtils.setAccessToken, accessToken)];
            case 3:
                _c.sent();
                return [4 /*yield*/, call(authUtils.setRefreshToken, refreshToken)];
            case 4:
                _c.sent();
                return [4 /*yield*/, call(signUpVerifiedEmailStartFlow)];
            case 5:
                _c.sent();
                _c.label = 6;
            case 6: return [3 /*break*/, 8];
            case 7:
                unknownError_6 = _c.sent();
                error = unknownError_6;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function signUpVerifiedEmailStartFlow() {
    var user, unknownError_7, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, call(getUser)];
            case 1:
                user = (_a.sent()).data;
                return [4 /*yield*/, put(authActions.getUser.actions.success(user))];
            case 2:
                _a.sent();
                logger.setValue({
                    type: loggerTypes.EValueType.UserEmail,
                    value: user.email || "",
                });
                if (user.unverifiedEmail) {
                    showAlert({
                        type: "error",
                        message: getLocalizedText("profile.email.unverified"),
                    });
                }
                return [3 /*break*/, 4];
            case 3:
                unknownError_7 = _a.sent();
                error = unknownError_7;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}
function signUpResendVerificationEmailStartFlow() {
    var user, _a, _b, unknownError_8, error;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                _b = (_a = authSelectors).getUser;
                return [4 /*yield*/, select()];
            case 1:
                user = _b.apply(_a, [_c.sent()]);
                if (!user) {
                    throw new Error("No user");
                }
                if (!user.unverifiedEmail) {
                    throw new Error("No unverified email");
                }
                return [4 /*yield*/, call(authApi.resendVerificationEmail, user.unverifiedEmail)];
            case 2:
                _c.sent();
                showAlert({
                    type: "info",
                    message: getLocalizedText("verify_email.info.description", {
                        email: user.unverifiedEmail,
                    }),
                });
                return [3 /*break*/, 4];
            case 3:
                unknownError_8 = _c.sent();
                error = unknownError_8;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}
function signUpResendVerificationSmsStartFlow() {
    var user, _a, _b, unknownError_9, error;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                _b = (_a = authSelectors).getUser;
                return [4 /*yield*/, select()];
            case 1:
                user = _b.apply(_a, [_c.sent()]);
                if (!user) {
                    throw new Error("No user");
                }
                if (!user.unverifiedPhone) {
                    throw new Error("No unverified phone");
                }
                return [4 /*yield*/, call(authApi.resendVerificationSms, user.unverifiedPhone)];
            case 2:
                _c.sent();
                showAlert({
                    type: "info",
                    message: getLocalizedText("verify_sms.info.description", {
                        phone: user.unverifiedPhone,
                    }),
                });
                return [3 /*break*/, 4];
            case 3:
                unknownError_9 = _c.sent();
                error = unknownError_9;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}
function getUserStartFlow(_) {
    var user, unknownError_10, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call(getUser)];
            case 1:
                user = (_a.sent()).data;
                return [4 /*yield*/, put(authActions.getUser.actions.success(user))];
            case 2:
                _a.sent();
                logger.setValue({
                    type: loggerTypes.EValueType.UserEmail,
                    value: user.email || "",
                });
                return [3 /*break*/, 5];
            case 3:
                unknownError_10 = _a.sent();
                error = unknownError_10;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.getUser.actions.failure({ error: error }))];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function genericSignInSuccessFlow(action) {
    var payload, accessToken, refreshToken, unknownError_11, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                accessToken = payload.accessToken, refreshToken = payload.refreshToken;
                cancelPendingCalls();
                return [4 /*yield*/, call(authUtils.setAccessToken, accessToken)];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(authUtils.setRefreshToken, refreshToken)];
            case 3:
                _a.sent();
                return [4 /*yield*/, put(socketActions.openSocket.actions.start({}))];
            case 4:
                _a.sent();
                return [4 /*yield*/, put(authActions.getUser.actions.start({}))];
            case 5:
                _a.sent();
                return [3 /*break*/, 7];
            case 6:
                unknownError_11 = _a.sent();
                error = unknownError_11;
                logger.logError({ error: error });
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function rehydrateFlow(action) {
    var key, user, _a, _b, hasAccessToken, _c, _d, unknownError_12, error;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                key = action.key;
                _e.label = 1;
            case 1:
                _e.trys.push([1, 6, , 7]);
                if (key !== "auth") {
                    return [2 /*return*/];
                }
                _b = (_a = authSelectors).getUser;
                return [4 /*yield*/, select()];
            case 2:
                user = _b.apply(_a, [_e.sent()]);
                if (user) {
                    logger.setValue({
                        type: loggerTypes.EValueType.UserEmail,
                        value: user.email || "",
                    });
                }
                _d = (_c = authSelectors).hasAccessToken;
                return [4 /*yield*/, select()];
            case 3:
                hasAccessToken = _d.apply(_c, [_e.sent()]);
                if (!hasAccessToken) return [3 /*break*/, 5];
                return [4 /*yield*/, put(socketActions.openSocket.actions.start({}))];
            case 4:
                _e.sent();
                _e.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                unknownError_12 = _e.sent();
                error = unknownError_12;
                logger.logError({ error: error });
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function updateUserStartStartFlow(action) {
    var payload, user, contact, onSuccess, updatedContact, updatedUser, unknownError_13, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                user = payload.user, contact = payload.contact, onSuccess = payload.onSuccess;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 9, , 11]);
                if (!(contact === null || contact === void 0 ? void 0 : contact.id)) return [3 /*break*/, 4];
                return [4 /*yield*/, call(updateContact, contact.id, contact)];
            case 2:
                updatedContact = (_a.sent()).data;
                return [4 /*yield*/, put(contactActions.updateContact.actions.success({
                        contactId: updatedContact.id,
                        contact: updatedContact,
                    }))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [4 /*yield*/, call(updateUser, user)];
            case 5:
                updatedUser = (_a.sent()).data;
                return [4 /*yield*/, put(authActions.updateUser.actions.success({
                        user: updatedUser,
                    }))];
            case 6:
                _a.sent();
                return [4 /*yield*/, put(contactActions.getContact.actions.start({
                        contactId: EContactCustomId.MeMaster,
                    }))];
            case 7:
                _a.sent();
                return [4 /*yield*/, put(contactActions.getContact.actions.start({
                        contactId: EContactCustomId.Me,
                    }))];
            case 8:
                _a.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(updatedUser);
                showAlert({
                    type: "success",
                    message: getGeneralUpdateSuccessText("user"),
                });
                return [3 /*break*/, 11];
            case 9:
                unknownError_13 = _a.sent();
                error = unknownError_13;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.updateUser.actions.failure({ error: error }))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function updateUserByIdStartStartFlow(action) {
    var payload, id, user, onSuccess, updatedUser, unknownError_14, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                id = payload.id, user = payload.user, onSuccess = payload.onSuccess;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(updateUserById, id, user)];
            case 2:
                updatedUser = (_a.sent()).data;
                return [4 /*yield*/, put(authActions.updateUserById.actions.success({
                        id: id,
                        user: updatedUser,
                    }))];
            case 3:
                _a.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(updatedUser);
                showAlert({
                    type: "success",
                    message: getGeneralUpdateSuccessText("user"),
                });
                return [3 /*break*/, 6];
            case 4:
                unknownError_14 = _a.sent();
                error = unknownError_14;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.updateUserById.actions.failure({ id: id, error: error }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function removeProfileStartFlow(action) {
    var payload, onSuccess, unknownError_15, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                onSuccess = payload.onSuccess;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(removeProfile)];
            case 2:
                _a.sent();
                return [4 /*yield*/, put(authActions.removeProfile.actions.success({}))];
            case 3:
                _a.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                return [3 /*break*/, 6];
            case 4:
                unknownError_15 = _a.sent();
                error = unknownError_15;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.removeProfile.actions.failure({ error: error }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function adminVerifyEmailStartFlow(action) {
    var payload, userId, data, unknownError_16, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                userId = payload.userId;
                return [4 /*yield*/, call(authApi.adminVerifyEmail, userId)];
            case 2:
                data = (_a.sent()).data;
                return [4 /*yield*/, put(authActions.adminVerifyEmail.actions.success({
                        data: data,
                    }))];
            case 3:
                _a.sent();
                showAlert({
                    type: "success",
                    message: getGeneralUpdateSuccessText("user"),
                });
                return [3 /*break*/, 6];
            case 4:
                unknownError_16 = _a.sent();
                error = unknownError_16;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.adminVerifyEmail.actions.failure({ error: error }))];
            case 5:
                _a.sent();
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function adminVerifyPhoneStartFlow(action) {
    var payload, userId, data, unknownError_17, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                userId = payload.userId;
                return [4 /*yield*/, call(authApi.adminVerifyPhone, userId)];
            case 2:
                data = (_a.sent()).data;
                return [4 /*yield*/, put(authActions.adminVerifyPhone.actions.success({
                        data: data,
                    }))];
            case 3:
                _a.sent();
                showAlert({
                    type: "success",
                    message: getGeneralUpdateSuccessText("user"),
                });
                return [3 /*break*/, 6];
            case 4:
                unknownError_17 = _a.sent();
                error = unknownError_17;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.adminVerifyPhone.actions.failure({ error: error }))];
            case 5:
                _a.sent();
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery("LOG_OUT", signOutFlow)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.signIn.types.START, signInStartFlow)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.signInAutomatically.types.START, signInAutomaticallyStartFlow)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.setAccessTokensWithoutSideEffects.getType(), setAccessTokensWithoutSideEffectsFlow)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.signUp.types.START, signUpStartFlow)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.signUpVerifyPhone.types.START, signUpVerifyPhoneStartFlow)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.signUpVerifiedEmail.getType(), signUpVerifiedEmailStartFlow)];
            case 7:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.signUpRequestTokenFromEmail.getType(), signUpRequestTokenFromEmailStartFlow)];
            case 8:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.adminVerifyEmail.types.START, adminVerifyEmailStartFlow)];
            case 9:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.adminVerifyPhone.types.START, adminVerifyPhoneStartFlow)];
            case 10:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.signUpResendVerificationEmail.getType(), signUpResendVerificationEmailStartFlow)];
            case 11:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.signUpResendVerificationSms.getType(), signUpResendVerificationSmsStartFlow)];
            case 12:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.getUser.types.START, getUserStartFlow)];
            case 13:
                _a.sent();
                return [4 /*yield*/, takeLatest([
                        authActions.signIn.types.SUCCESS,
                        authActions.signInAutomatically.types.SUCCESS,
                        authActions.signUpVerifyPhone.types.SUCCESS,
                    ], genericSignInSuccessFlow)];
            case 14:
                _a.sent();
                return [4 /*yield*/, takeLatest("persist/REHYDRATE", rehydrateFlow)];
            case 15:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.updateUser.types.START, updateUserStartStartFlow)];
            case 16:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.updateUserById.types.START, updateUserByIdStartStartFlow)];
            case 17:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.removeProfile.types.START, removeProfileStartFlow)];
            case 18:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// eslint-disable-next-line import/no-default-export
export default saga;
